<template>
	<RightPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<ModalVScrollable class="member-list"
			title="メンバー一覧"
			header_height="115"
			bottom_height="0"
			v-on:close="onClose"
			ref="content"
		>
			<template v-slot:header>
				<v-layout row class="modal-header-filter">
					<v-btn v-if="$store.getters['chart/isEditable']" fab flat absolute 
						class="pa-0 ma-0 add-member white--text">追加</v-btn>
					<v-flex xs10 class="mx-2">
						<v-text-field dark clearable height="23" 
							placeholder="名前で検索" 
							color="white" 
							single-line
							v-model="filter_name"
						></v-text-field>
					</v-flex>
					<v-flex xs2 class="mx-2">
						<v-btn flat icon blue 
							color="white" 
						>
							<v-icon>filter_list</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
			</template>
			<template v-if="value">
				<RightPaneMemberListRowOuter v-for="m in filtered_members"
					:key="m.code" 
					v-bind:item="m"
					v-bind:watchSlide="watchSlide"
					v-bind:isSelected="value.member_code === m.code"
					v-bind:isLoginUser="login_user_code === m.code"
					v-bind:mode=isMode
					v-on:member-selected="onClickMemberSelected"
					v-on:show-member-info="onClickShowMemberInfo"
					v-on:member-list-row-slide="onMemberListRowSlide"
				/>
			</template>
		</ModalVScrollable>
	</RightPane>
</template>
<script>
import RightPane from './RightPane';
import ModalVScrollable from './ModalVScrollable';
import RightPaneMemberListRowOuter from'./RightPaneMemberListRowOuter';
import Util from '../classes/Util';
import clonedeep from 'lodash/cloneDeep';

export default {
	name: 'RightPaneMemberList',
	props: [
		'value',
	],
	components: {
		RightPane,
		ModalVScrollable,
		RightPaneMemberListRowOuter,
	},
	data: function() {
		return {
			login_user_code : this.$store.getters['loginUser'].code,
			watchSlide: null,
			filter_name: '',
		}
	},
	methods: {
		onClose: function() {
			this.$emit('close');
		},
		onClick: function() {
			return false;
		},
		onClickMemberSelected: function(e) {
			this.$emit('member-selected', e);
		},
		onMemberListRowSlide: function(e) {
			this.watchSlide = {
				type: 'slide',
				target: e.target,
				status: e.status,
			};
		},
		onClickShowMemberInfo: function(e) {
			this.$emit("show-member-info", e);
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		filtered_members: function() {
			let ret = clonedeep(this.$store.getters['listMember']);
			
			if (this.value.member_code !== null 
				&& this.value.member_code !== undefined
				&& String(this.value.member_code).length > 0){
					let obj = ret.filter(m => m.code === this.value.member_code)[0];
					Util.arrayMoveToTop(ret,obj);
			}
			
			if (this.$route.name === 'GanttTimeBoardList'){
				if (this.login_user_code != null && String(this.login_user_code).length > 0){
					let obj = ret.filter(m => m.code === this.login_user_code)[0];
					Util.arrayMoveToTop(ret,obj);
				}
			}
			if (this.filter_name) {
				ret = ret.filter( row => {
					return row.name.search(Util.replaceEscapeString(this.filter_name)) >= 0;
				});
			}
			return ret;
		},
		isFiltering: function() {
			return false;
		},
		isMode: function(){
			if (this.value != null){
				return this.value.mode
			}
			return false;
		}
	},
}
</script>
<style>
	.member-list.modal-window .add-member {
		top: 0px;
		left: 0px;
	}
	.member-list.modal-window .modal-header-filter {
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>
<style scoped >

</style>